export const isEmptyObject = <T extends object>(obj: T): boolean => !Object.keys(obj).length;
export type NullableOptional<T> = {
  [K in keyof T]?: T[K] | null | undefined;
};

export type MakeRequired<T, K extends keyof T> = Omit<T, K> & Required<Pick<T, K>>;
